import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const MoonIcon = ({
  width = 16,
  height = 16,
  stroke = '#52575C',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M14 8.527c-.105 1.134-.53 2.216-1.228 3.118-.697.901-1.636 1.585-2.708 1.973-1.072.387-2.232.46-3.344.213-1.113-.248-2.131-.808-2.937-1.614S2.417 10.393 2.169 9.28c-.248-1.112-.174-2.272.213-3.344s1.072-2.011 1.973-2.708C5.257 2.53 6.338 2.105 7.473 2c-.664.899-.984 2.006-.9 3.12.082 1.116.563 2.163 1.353 2.954.79.79 1.838 1.27 2.953 1.354 1.115.083 2.222-.237 3.12-.901z"
    />
  </svg>
);
